import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PayNowOption({ onContinue }) {
  return (
    <div className="mb-6">
      <div className="p-4 sm:p-5 border border-blue-200 bg-secondary-blue rounded-lg">
        <p className="text-xs uppercase tracking-widest font-bold text-primary-blue">
          Another way to check out
        </p>
        <h3 className="text-xl sm:text-2xl font-extrabold my-2">Pay by Bank</h3>
        <p className="text-sm text-gray-700 mb-3">
          Complete your purchase today using your business bank account.
        </p>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-gray-700">
          <span>No fees</span>
          <span className="pl-4 border-l border-primary-border-gray">
            Secure bank transfer
          </span>
        </div>
        <button
          type="button"
          onClick={onContinue}
          className="mt-4 inline-flex flex-wrap items-center gap-2 font-bold text-sm text-primary-blue hover:text-primary-blue-hover"
        >
          Continue to Pay by Bank
          <FontAwesomeIcon icon={['far', 'arrow-right']} />
        </button>
      </div>
    </div>
  );
}
